import React from "react";
import champagne from "../assets/images/others/champagne.png";
import tableFootball from "../assets/images/others/tablefootball.png";
import pourDrink from "../assets/images/others/pouringDrink.png";

const HappyHour = () => {
  return (
    <>
      <div className="bigHH  d-none d-lg-block">
        <div className="container-fluid third">
          <div className="row">
            <div className="col-6 oneimage">
              <img className="col-12 image1" src={champagne} alt="champagne" />
            </div>
            <div className="col-6 twoimage">
              <div className="smallimages">
                <img
                  className="col-6 image2"
                  src={tableFootball}
                  alt="table football"
                />
              </div>
              <div className="smallimages">
                <img className="col-6 image3" src={pourDrink} alt="negroni" />
              </div>
            </div>
          </div>
        </div>{" "}
        <div className="hhText">
          <h3>
            Longest Happy <br /> Hour Around <br />{" "}
            <span className="happyhour_time">Daily: 4 - 10PM</span>
          </h3>
        </div>
        <div className="hhTextDescription">
          <h6>TASTY BITES AND COSMIC COCKTAILS</h6>
          <p>
            Whether you're on a solo exploration mission or come in peace with
            your crew, you'll be sure to love our bar snacks. The perfect
            complement to your cosmic cocktail, our food is created with love in
            our kitchen and perfect to share.
          </p>
        </div>{" "}
      </div>
      <div className="smallHH d-lg-none">
      <div className="hhTextSmall mb-5">
          <h3>
            Longest Happy <br /> Hour Around <br />{" "}
            <span className="happyhour_time">Daily: 4 - 10PM</span>
          </h3>
        </div>
        <div className="hhTextDescriptionSmall mb-5">
          <h6>TASTY BITES AND COSMIC COCKTAILS</h6>
          <p>
            Whether you're on a solo exploration mission or come in peace with
            your crew, you'll be sure to love our bar snacks. The perfect
            complement to your cosmic cocktail, our food is created with love in
            our kitchen and perfect to share.
          </p>
        </div>
        <div className="container-fluid thirdSmall">
          <div className="row">
            <div className="col-md-6 mb-3">
                <img
                  className="w-100"
                  src={tableFootball}
                  alt="table football"
                />
            </div>
            <div className="col-md-6 mb-3">
              <img className="w-100" src={pourDrink} alt="negroni" />
            </div>
            <div className="col-md-12">
              <img className="w-100" src={champagne} alt="champagne" />
            </div>
          </div>
        </div>{" "}
      
       
      </div>
    </>
  );
};

export default HappyHour;
